<!-- Navigation bar: "Meu Financeiro" (left), "Conectar Contas" + "Ajuda" + notification bell (right) per prototype -->
<nav class="nav-actions">
  @if (showMyFinance) {
    <button
      class="cds-button s-hollow c-primary nav-actions__my-finance"
      type="button"
      (click)="goToMyFinance()"
    >
      <i class="cds-icon-home" aria-hidden="true"></i>
      Meu Financeiro
    </button>
  }

  <aside class="nav-actions__right">
    @if (showConnectAccounts) {
      <button
        class="cds-button s-hollow c-primary nav-actions__connect-accounts"
        type="button"
        (click)="connectAccounts()"
      >
        Conectar Contas
      </button>
    }

    <button
      class="cds-button s-hollow c-primary nav-actions__help"
      type="button"
      (click)="openHelp()"
    >
      <i class="cds-icon-question-circle" aria-hidden="true"></i>
      Ajuda
    </button>

    <!-- Notification Center -->
    <caixa-webcomponent-notification-center />
    <!-- ! Notification Center -->
  </aside>
</nav>
